import React from 'react';
import ReactDOM from 'react-dom/client';
import { randomString } from '../utils/web/webUtils.js';
import Alert from './alert/alert.js';
import Dialog from './dialog/dialog.js';
import NotifySnackbar from './notifySnackbar/notifySnackbar.js';
export function createAlert(message, options = {}) {
  var alertRoot = document.createElement('div');
  alertRoot.classList.add('alertRoot');
  document.body.append(alertRoot);
  var darkMode = false;
  var appLayout = document.querySelector('.appLayout');

  if (appLayout && appLayout.classList.contains('darkMode')) {
    darkMode = true;
  }

  return new Promise(resolve => {
    var root = ReactDOM.createRoot(alertRoot);
    root.render( /*#__PURE__*/React.createElement(Alert, {
      // default props
      darkMode,
      header: options.confirmBox ? 'Confirm' : 'Attention',
      ...options,
      close: (...args) => {
        var [event] = args;
        var confirmResult = event?.target?.closest('.buttonContainer')?.classList.contains('okayButton');
        root.unmount();
        alertRoot.remove();

        if (typeof options.close === 'function') {
          options.close(...args);
        }

        resolve(typeof confirmResult === 'boolean' ? confirmResult : null);
      }
    }, // props
    message // children
    ));
  });
}
export function confirmProm(message, options = {}) {
  options.confirmBox = true;
  return createAlert(message, options);
}
export function createNotify(message, options = {}) {
  var notifyRoot = document.createElement('div');
  notifyRoot.classList.add('notifyRoot');
  var notifyContainer = document.querySelector('.notifySnackbarsContainer');

  if (!notifyContainer) {
    notifyContainer = document.createElement('div');
    notifyContainer.classList.add('notifySnackbarsContainer');
    document.body.append(notifyContainer);
  }

  notifyContainer.append(notifyRoot);
  var darkMode = false;
  var appLayout = document.querySelector('.appLayout');

  if (appLayout && appLayout.classList.contains('darkMode')) {
    darkMode = true;
  }

  return new Promise(resolve => {
    var key = randomString();
    var root = ReactDOM.createRoot(notifyRoot);
    root.render( /*#__PURE__*/React.createElement(NotifySnackbar, {
      // default props
      darkMode,
      key,
      ...options,
      close: (...args) => {
        var [event] = args; // var confirmResult = event?.target?.closest('.buttonContainer')?.classList.contains('okayButton');

        root.unmount();
        notifyRoot.remove();

        if (typeof options.close === 'function') {
          options.close(...args);
        } // resolve(typeof confirmResult === 'boolean' ? confirmResult : null);


        resolve();
      }
    }, // props
    message // children
    ));
  });
}
export function createNotifyError(message, options = {}) {
  options.notifyError = true;
  return createNotify(message, options);
}
export function createDialog(message, options = {}) {
  var dialogRoot = document.createElement('div');
  dialogRoot.classList.add('dialogRoot');
  document.body.append(dialogRoot);
  var darkMode = false;
  var appLayout = document.querySelector('.appLayout');

  if (appLayout && appLayout.classList.contains('darkMode')) {
    darkMode = true;
  }

  return new Promise(resolve => {
    var root = ReactDOM.createRoot(dialogRoot);
    root.render( /*#__PURE__*/React.createElement(Dialog, {
      // default props
      darkMode,
      ...options,
      close: (...args) => {
        root.unmount();
        dialogRoot.remove();

        if (typeof options.close === 'function') {
          options.close(...args);
        }

        resolve();
      }
    }, // props
    message // children
    ));
  });
}